import { IconSuccess, SharedButton } from "@components";
import { PATH_HEALTH_RECORDS } from "@configs";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import styled from "styled-components";

export const Result = () => {
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <StyledSection>
      <IconSuccess />
      <h4>Success</h4>
      <h5>Congratulations on your process successfully!</h5>
      <p>Shortly you will find a reproductive health records data in your SRHR Program!</p>
      <SharedButton type="primary" size="middle" onClick={() => history.push(PATH_HEALTH_RECORDS)}>
        {t("page.continue")}
      </SharedButton>
    </StyledSection>
  );
};
const StyledSection = styled.section`
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  background: #fff;
  border-radius: 10px;
  padding: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 1rem;
  max-width: 960px;
  h4 {
    font-size: 30px;
    color: #00aa67;
  }
  h5 {
    font-size: 16px;
  }
`;
